// Global axios interceptor: on any 401, drop the session and redirect to /login.
// Applied to the DEFAULT axios instance so all existing `axios.get/post` calls
// across pages benefit without a rewrite.
import axios from 'axios';

let installed = false;

export function setupAxiosInterceptors() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (status === 401) {
        if (window.location.pathname !== '/login') {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );
}
